import { AsyncPipe } from '@angular/common';
import {
  Component,
  Input,
} from '@angular/core';
import { Item } from '@dspace/core/shared/item.model';

import { MetadataValuesComponent } from '../../../../field-components/metadata-values/metadata-values.component';
import { ImageField } from '../image-field';
import { ItemPageFieldComponent } from '../item-page-field.component';

@Component({
  selector: 'ds-item-page-img-field',
  templateUrl: '../item-page-field.component.html',
  imports: [
    AsyncPipe,
    MetadataValuesComponent,
  ],
})
/**
 * Component that renders an inline image for a given field.
 * This component uses a given {@code ImageField} configuration to correctly render the img.
 */
export class ItemPageImgFieldComponent extends ItemPageFieldComponent {

  /**
   * The item to display metadata for
   */
  @Input() item: Item;

  /**
   * Separator string between multiple values of the metadata fields defined
   * @type {string}
   */
  @Input() separator: string;

  /**
   * Fields (schema.element.qualifier) used to render their values.
   */
  @Input() fields: string[];

  /**
   * Label i18n key for the rendered metadata
   */
  @Input() label: string;

  /**
   * Image Configuration
   */
  @Input() img: ImageField;

  /**
   * Whether any valid HTTP(S) URL should be rendered as a link
   */
  @Input() urlRegex?: string;

}
